module.exports = __webpack_public_path__ + "static/media/faq_especialistas_mobile.6a3b7e76.jpg";